import { InputMask } from './types'

// Mirrors TextInput's historical `format='integer'` behavior byte-for-byte.
//
// IMPORTANT: the blur normalization is LOSSY by design — it runs the value
// through `Number(...)`, which strips leading zeros (`007` -> `7`) and loses
// precision beyond `Number.MAX_SAFE_INTEGER` (~16 digits). This is intentional
// for integer *quantities* and CANNOT be changed without breaking the many
// existing callers that depend on it. Use `digitsFormat` for identifiers
// that must be preserved verbatim.
const integerPattern = /^\d*$/

export const integerFormat: InputMask = {
  sanitize: (input) => (integerPattern.test(input) ? input : null),
  format: (raw) => raw,
  normalizeOnBlur: (raw) => Number(raw).toFixed(0),
  placeholder: '0',
}
